var MultiChainID = /* @__PURE__ */ ((MultiChainID2) => {
  MultiChainID2[MultiChainID2["Bitcoin"] = 0] = "Bitcoin";
  MultiChainID2[MultiChainID2["Ether"] = 60] = "Ether";
  MultiChainID2[MultiChainID2["Sui"] = 784] = "Sui";
  MultiChainID2[MultiChainID2["Nostr"] = 1237] = "Nostr";
  MultiChainID2[MultiChainID2["Rooch"] = 20230101] = "Rooch";
  return MultiChainID2;
})(MultiChainID || {});
export {
  MultiChainID
};
//# sourceMappingURL=types.js.map
